<template>
    <div>
        <paid-modal v-if="!is_paid_ " hot-key/>
        <max-offer-modal
            v-if="max_users_reached && showMaxUsersModal"
            :is_users_small_team="paid_type == 'small_team'"
            :is_users_large_team="paid_type == 'large_team'"
            @closeModal="showMaxUsersModal = false"
        />
        <title>{{ $t('companyusers.text_0') }} - DOFFERO®</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
        <div class="title">
            <under-bar-name :title="$t('companyusers.text_1')" :margin="false"></under-bar-name>
            <max-offer-client :numerator="users.length" :denominator="number_of_users" :title="$t('offer.companyusers_title')"/>
        </div>
        <div class="cont">
            <h1>{{ $t('companyusers.text_2') }}</h1>
            <h3>
                {{ $t('companyusers.text_3') }}
            </h3>
            <div class="main">
                <h2 class="nadpis">{{ $t('companyusers.text_4') }}</h2>
                <action-company-users :is_paid="is_paid_" :data="user" @stop="user = {}" @create="create($event)" 
                @showMaxUsersModal="showMaxUsersModal = true"
                :max_users_reached="max_users_reached" />
            </div>
            <div v-if="users.length > 0">
                <h2 class="nadpis">{{ $t('companyusers.text_5') }}</h2>
                <div class="table-responsive" style="overflow-x: inherit;">
                    <table-company-users :users="users" @edit="edit($event)" @remove="remove($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaxOfferClient from '../../../layouts/Header/MaxOfferClient.vue';
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'  
import UnderBarName from '../../../layouts/Header/UnderBarName.vue'
import ActionCompanyUsers from './components/ActionCompanyUsers.vue'
import TableCompanyUsers from './components/TableCompanyUsers.vue'
import PaidModal from '../../vue_components/PaidModal.vue'
export default {
    components: { ActionCompanyUsers, TableCompanyUsers, UnderBarName, MaxOfferClient, PaidModal },
    props: ['data', 'premium', 'is_paid', 'paid_type'],
    data() {
        return {
            users: [],
            user: {},
            users_count_small_team: 5,
            users_count_large_team: 20,
            showMaxUsersModal: false
        }
    },
    created() {
        this.users = this.data
    },
    computed: {
        is_paid_() {
            if (this.paid_type == 'free' || this.paid_type == 'profi') {
                return 0;
            }
            return 1;
        },
        max_users_reached(){
            if(this.paid_type == 'small_team' && this.users.length >= this.users_count_small_team){
                return 1;
            }
            if(this.paid_type == 'large_team' && this.users.length >= this.users_count_large_team){
                return 1;
            }
            return 0;
        },
        number_of_users(){
            if(this.paid_type == 'small_team'){
                return this.users_count_small_team;
            }
            if(this.paid_type == 'large_team'){
                return this.users_count_large_team;
            }
            return 0;
        }
    },
    methods: {
        edit(user) {
            this.user = user
        },
        create(user) {
            let text, data;
            text = this.$t('companyusers.text_create_success');
            data = user;
            if (user.id) {
                text = this.$t('companyusers.text_edit_success');
                data = {
                    id: user.id,
                    meno: user.meno,
                    priezvisko: user.priezvisko,
                    email: user.email,
                    heslo: user.heslo,
                    access_option: user.access_option
                };
            }
            this.makeApiCall('/api/companyUsers', data, text);
        },
        remove(user) {
            swal.fire({
                    title: this.$t('offer.companyusers_delete_title'),
                    text: this.$t('offer.companyusers_delete_text'),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    cancelButtonText: this.$t('offer.companyusers_delete_btn'),
                    confirmButtonText: this.$t('offer.companyusers_move_btn'),
                })
                .then((result) => {
                    const text = !result.value ?  this.$t('offer.companyusers_deleted_msg') : this.$t('offer.companyusers_moved_msg')
                    const data = {
                        delete: true,
                        id: user.id,
                        remove_offes: !result.value //true remove offers, false add offers to main account
                    }; 
                    this.makeApiCall('/api/companyUsers', data, text);
                });
        },
        getUsers() {
            axios.get('/api/companyUsers').then(response => {
                this.users = response.data;
            });
        },
        makeApiCall(url, data, successText) {
            axios.post(url, data).then(response => {
                if (response.data === "email") {
                    this.$toast.error(this.$t('companyusers.error_email_exists'), { timeout: 3038 });
                } else if(response.data === "free") {
                    this.$toast.error("Nemáte žiadny platený balík", { timeout: 3038 });
                } else if(response.data === "small_team") {
                    this.$toast.error("Dosiahol si svoj limit účtov pre Malý tím", { timeout: 3038 });
                } else if(response.data === "large_team") {
                    this.$toast.error("Dosiahol si svoj limit účtov pre veľký tím", { timeout: 3038 });
                } else {
                    if (successText) this.$toast.success(successText, { timeout: 3038 });
                    this.getUsers();
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
* {
    font-family: Roboto;
}

.error {
    width: 473px;
    height: 60px;
    margin: 15px auto;
    background: #FFEBEE;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 800;
    font-size: 14px;
    line-height: 182.5%;
    color: #DB355F;

    svg {
        margin-right: 10px;
    }
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1188px;
    margin: 65px auto 0 auto;

    @media only screen and (max-width: 1500px) {
        width: 95%;
    }
}

.cont {
    width: 1188px;
    margin: 50px auto 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    padding: 57px 0 140px 0;

    @media only screen and (max-width: 1500px) {
        width: 95%;
    }

    .nadpis {
        width: 474px;

        @media only screen and (max-width: 600px) {
            width: 90%;
            text-align: center;
        }

        margin: 0 auto 20px auto;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: #000000;
    }

    h1 {
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }

        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        line-height: 42px;
        text-align: center;
        color: #2e0808;
    }

    h3 {
        width: 740px;

        @media only screen and (max-width: 600px) {
            width: 90%;
        }

        margin: 23px auto 36px auto;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
        color: #9598A7;
    }

    .main {
        width: 1030px;
        margin: 0 auto;
        background: #F2F7FB;
        border-radius: 5px;
        padding: 30px 0 50px 0;
        margin-bottom: 50px;

        @media only screen and (max-width: 1500px) {
            width: 90%;
        }

        .nadpis {
            width: 474px;

            @media only screen and (max-width: 600px) {
                width: 90%;
                text-align: center;
            }

            margin: 0 auto 20px auto;
            text-align: center;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 28px;
            color: #000000;
        }

        .ulozit {
            width: 474px;

            @media only screen and (max-width: 600px) {
                width: 90%;
            }

            height: 55px;
            margin: 37px auto 75px auto;
            background: #2ED8B6;
            border-radius: 4px;

            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            color: #FFFFFF;
            cursor: pointer;
            transition: .5s all;

            &:hover {
                background: #23caa9;
            }
        }
    }
}
</style>